import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-block-sns-card',
  templateUrl: './block-sns-card.component.html',
  styleUrls: ['./block-sns-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlockSnsCardComponent {}
